import {
    XhsDetail,
    editXhsDetail,
    editXhsDetail2,
    queryXhsCategoryProperties,
    xhsBatchUpdateCategory,
    queryXhsCategoryPropertiesValue,
    getLogisticsList,
    getBrandList,
    mappingVariations,
    getVariations,
    xhsSpecAutoMerge,
    getAttributeValues,
    editXhsCarouselVideo,
    getDeliveryRule,
    getCarriageTemplateList,
    saveBatchTempConf,
    queryBatchDetail,
    saveBatchTempPrice,
    batchPublishItem,
} from '@/api/prod/center/index';
import store from '@/store'


// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (r.skuList && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            delete item._skuid
            return isRequest ? {
                ...item,
                imageUrl: item.skuSpecifications[0].imageUrl,
                marketPrice: item.marketPrice || 0,
                skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
                ...item,
                skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }

    return isRequest ? {
        ...r,
        categoryLeafId: r.categoryIds[r.categoryIds.length - 1],
        parentCategoryId: r.categoryIds[r.categoryIds.length - 2],
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
        templateConfig: r.templateConfig ? JSON.stringify(r.templateConfig) : null,
    } : {
        ...r,
        attrs: r.attrs ? r.attrs : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        // headImgs: r.headImgs ? JSON.parse(r.headImgs) : [],
        // descInfo: r.descInfo ? JSON.parse(r.descInfo) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
        productType: 1, // 目前只支持实物商品
    }
}
// 获取详情资料
export function getXhsDetail(baseItemId) {

    return XhsDetail(baseItemId).then(res => {
        if (res.result === 1) {
            return _formatGoodsItem(res.data)
        } else {
            return false
        }
    })
}

// 查询类目属性
export function getCategoryProps(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('xhs');
    let _data = {
      ...data,
      shopId: data.shopId ? data.shopId : _shopId // 默认店铺
    }
    return queryXhsCategoryProperties(_data).then(res => {
      if (res.result === 1) {
        return getCategoryPropsValue(res.data)
      } else {
        return []
      }
    })
}

// 查询类目属性的值
export async function getCategoryPropsValue(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('xhs');
    if(!data?.attributeV3s?.length) return []
    let promises = data.attributeV3s.map(item=>{
        return queryXhsCategoryPropertiesValue({
            shopId:_shopId,
            attributeId:item.id
        }).then(res => {
            let values = res.data.attributeValueV3s;
            if(values.length>0){
                item.values = values;
                item.type='select_one';
            }
            return item;
        });
    })
    let results = await Promise.all(promises); 
    return results;
}

export function editXhsInfo(params) {
    return editXhsDetail(_formatGoodsItem(params, true)).then(res => {
        if (res.result === 1) {
        return true;
        }
        return false;
    })
}
export function editXhsInfo2(data,expandParams) {
    let params = _formatGoodsItem(data, true)
    params = {
        itemInfo:{...params},
        ...expandParams
    }
    return editXhsDetail2(params).then(res => {
        if (res.result === 1) {
        return true;
        }
        return false;
    })
}


// 获取物流方案
export async function logisticsList(shopId, config = {}) {
    shopId = shopId || store.getters.shops_getCategoryPropShopId('xhs');
    return getLogisticsList({shopId}, config).then(res => {
        if (res.result === 1) {
            return res;
        }
        return false;
    })
}

// 获取品牌列表
export async function queryBrandList(data, config = {}) {
    return getBrandList(data, config).then(res => {
        if (res.result === 1) {
            return res;
        }
        return false;
    })
}

// 获取规格映射
export async function getMappingVariations(data) {
    return mappingVariations(data).then(res => {
        if (res.result === 1) {
            return res.data || {};
        }
        return {};
    })
}

// 获取规格列表
export async function variations(data) {
    return getVariations(data).then(res => {
        if (res.result === 1) {
            return res;
        }
        return false;
    })
}
// 获取小红书规格重新获取
export function specAutoMerge(data) {
    return xhsSpecAutoMerge(data).then(res => {
        if (res.result === 1) {
            return res?.data || {};
        }
        return {};
    })
}

// 获取规格值
export async function attributeValues(data) {
    return getAttributeValues(data).then(res => {
        if (res.result === 1) {
            return res;
        }
        return false;
    })
}
export async function editCarouselVideo(data) {
    return editXhsCarouselVideo(data).then(res => {
        if (res.result === 1) {
        return res.data || null;
        }
        return null;
    })
}


// 批量修改类目
export function batchXhsCategory(data) {
    return xhsBatchUpdateCategory(data).then(res => {
        if (res.result === 1) {
        return true
        } else {
        return false
        }
    })
}
// 获取运费模版列表
export function getXhsCarriageTemplateList(data, config) {
    return getCarriageTemplateList(data, config).then(res => {
        if (res.result === 1) {
            return res.data || {}
        } else {
            return false
        }
    })
}

// 获取发货时间规则
export function getXhsDeliveryRule(data) {
    return getDeliveryRule(data).then(res => {
        if (res.result === 1) {
            return res.data || {}
        } else {
            return {}
        }
    })
}
// 批量铺货相关API
export const saveBatchTempConfXhs= (data) => {
  return saveBatchTempConf({data,platform:'xhs'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
export const queryBatchDetailXhs = (data) => {
  return queryBatchDetail({data,platform:'xhs'}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const saveBatchTempPricePlatForm = (data) => {
  return saveBatchTempPrice({data,platform:'xhs'}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchPublishItemXhs = (data) => {
  return batchPublishItem({data,platform:'xhs'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}